import { useMemo } from 'react';

import { AvailableFeatureFlags } from 'data/generated/graphql';
import { usePublicationSettings } from './publication-settings';

export function useFeatureFlag(featureFlagName: AvailableFeatureFlags): boolean | null;
export function useFeatureFlag<D extends boolean | null>(
  featureFlagName: AvailableFeatureFlags,
  defaultValue: D
): boolean | D;
export function useFeatureFlag(
  featureFlagName: AvailableFeatureFlags,
  defaultValue: boolean | null = null
): boolean | null {
  const { data: publicationSettingsResp } = usePublicationSettings();

  const flagValue = useMemo(() => {
    if (publicationSettingsResp?.publicationSetting.featureFlags) {
      const flags = publicationSettingsResp.publicationSetting.featureFlags;

      const featureFlag = flags.find((flag) => flag.name === featureFlagName);

      if (featureFlag) {
        return featureFlag.enabled;
      }

      console.warn(`Feature flag with name "${featureFlagName}" not found in publication settings.`);
    }

    return defaultValue;
  }, [defaultValue, featureFlagName, publicationSettingsResp?.publicationSetting.featureFlags]);

  return flagValue;
}
